import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { MenuBlock } from 'moduleBase/types/Menu';
import classNames from 'classnames';
import { useMediaIsDesktop } from '@collaborator/npm_modules/dist/components/media';
import { FC } from 'react';

type PropsType = {
  block: MenuBlock,
  hide: () => void,
  itemClassName?: string,
};

const Menu: FC<PropsType> = ({
  block,
  hide,
  itemClassName,
}) => {
  const isDesktop = useMediaIsDesktop();

  const items = React.useMemo(() => block.items.filter(
    (item) => !isDesktop || (isDesktop && item.isVisibleDesktop),
  ), [block.items, isDesktop]);

  return (
    <>
      {items.map((menuItem) => (
        <div
          key={menuItem.label}
          className={classNames('dropdown-flat-list__item', itemClassName)}
        >
          <MenuItem
            {...menuItem}
            onClick={() => {
              hide();
            }}
          />
        </div>
      ))}
    </>
  );
};

export { Menu };
